import styled from 'styled-components'
import { BaseInput, BaseTextArea } from 'components/Inputs/Base'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 100px;
`

export const Row = styled(Container)`
  width: 100%;
  padding: 0px;
  gap: 10px;
  margin-bottom: 15px;
  flex-direction: row;
  align-items: flex-start;
`

export const CheckRow = styled(Row)`
  margin-bottom: 10px;
  align-items: center;

  label, p {
    cursor: pointer;
    margin-bottom: 1px;
  }
`

export const CalendarContainer = styled(Container)`
  padding: 0px;
  margin: 0px 30px 0px 0px;
`

export const FormField = styled(Container)`
  flex: 1;
  justify-content: flex-end;
  padding: 0px;
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #F7F7F7;
  margin: 10px 0px;
  border-radius: 15px;
`

export const Input = styled(BaseInput)`
  width: 100%;
`

export const TextArea = styled(BaseTextArea)`
  width: 100%;
`

export const Title = styled.h2`
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 20px;
  align-self: center;
`;

export const InfoText = styled.p`
  text-align: center;
  color: #FFFFFF;
  margin: 0px;
`

export const WarningText = styled(InfoText)`
  color: #FF3939;
  line-height: 18px;
  margin-top: 5px;
`

export const Label = styled.label`
  margin-bottom: 5px;
  color: #777777;
`

export const ErrorContainer = styled.div`
  padding: 9px;
  margin-bottom: 15px;
  width: 100%;
  border-radius: 15px;
  align-items: center;
  background-color: #FF3939;
`
